/*
 *  Copyright (C) 2017 Atelier Cartographique <contact@atelier-cartographique.be>
 *
 *  This program is free software: you can redistribute it and/or modify
 *  it under the terms of the GNU General Public License as published by
 *  the Free Software Foundation, version 3 of the License.
 *
 *  This program is distributed in the hope that it will be useful,
 *  but WITHOUT ANY WARRANTY; without even the implied warranty of
 *  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 *  GNU General Public License for more details.
 *
 *  You should have received a copy of the GNU General Public License
 *  along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */

import debug from 'debug';

import { Feature, FeatureViewOptions } from '../../source';

import config from './config';
import default_ from './default';

const logger = debug('sdi:feature-view');

export const renderConfig = (
    viewOptions: FeatureViewOptions,
    feature: Feature,
    metadataId: string,
    asTableRow = false,
) => {
    switch (viewOptions.type) {
        case 'default':
            return default_(feature, viewOptions, metadataId, asTableRow);
        case 'config':
            return config(feature, viewOptions, metadataId, asTableRow);
    }
};
export default renderConfig;

logger('loaded');
